// upsell crossell

async function getRelatedid() {
  const arr_ids_related = [];
  const unique_ids = new Set();

  async function getCartData() {
    try {
      const cartData = await fetch("/cart.json");
      return await cartData.json();
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return null;
    }
  }

  async function fetchRelatedProducts(productId, limit) {
    try {
      document.querySelector('.product-recommendations_cart .loading__spinner').classList.remove("hidden");
      const response = await fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=${limit}&intent=related`);
      if (!response.ok) throw new Error(`Failed to fetch recommendations: ${response.status}`);
      const jsonData = await response.json();
      return jsonData.products || [];
    } catch (error) {
      console.error(`Error fetching related products for Product ID ${productId}:`, error);
      return [];
    }
  }

  function renderRecommendations(products) {
    const container = document.querySelector(".product-recommendations_cart ul");
    document.querySelector('.product-recommendations_cart .loading__spinner').classList.add("hidden");
    if (!container) return;

    let htmlContent = products.map((product) => {
      const variantId = product.variants?.[0]?.id || null;
      return `
        <div class="recommendation-item" data-product-id="${product.id}">
          <img src="${product.images[0]}" alt="${product.title}" class="recommendation-image" />
          <div class="recommendation-item-info" data-product-id="${product.id}">
            <h3 class="h4 recommendation-title">${product.title}</h3>
            <p class="recommendation-price">Price: £${(product.price / 100).toFixed(2)}</p>
            <cart-add-button variant-id="${variantId}" product-title="${product.title}"></cart-add-button>
          </div>
        </div>
      `;
    }).join("");

    container.innerHTML += htmlContent;
  }

  try {
    const cartData = await getCartData();
    if (!cartData) return;

    cartData.items.forEach(item => arr_ids_related.push(item.product_id));
    const unique_ids_for_related = [...new Set(arr_ids_related)];

    const totalLimit = unique_ids_for_related.length === 1 ? 2 : 4;
    let totalRendered = 0;

    for (const productId of unique_ids_for_related) {
      if (totalRendered >= totalLimit) break;

      const remainingLimit = totalLimit - totalRendered;
      const relatedProducts = await fetchRelatedProducts(productId, remainingLimit);
      const uniqueProducts = relatedProducts.filter(p => !unique_ids.has(p.id));
      uniqueProducts.forEach(p => unique_ids.add(p.id));

      const productsToRender = uniqueProducts.slice(0, remainingLimit);
      renderRecommendations(productsToRender);

      totalRendered += productsToRender.length;
    }
  } catch (error) {
    console.error("Error in getRelatedid:", error);
  }
}

if (!customElements.get('cart-add-button')) {
  customElements.define(
    'cart-add-button',
    class CartAddButton extends HTMLElement {
      constructor() {
        super();
        this.variantId = this.getAttribute('variant-id');
        this.productTitle = this.getAttribute('product-title') || 'Product';
        this.render();
        this.querySelector('button').addEventListener('click', this.addToCart.bind(this));
      }

      render() {
        this.innerHTML = `
          <button class="custom-add-to-cart-button button button--secondary">
            <div class="loading__spinner hidden">
              <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
              </svg>
            </div>
            Add to Cart
          </button>
        `;
      }

      async addToCart(e) {
        e.preventDefault();
        const btn = e.currentTarget;
        const spinner = btn.querySelector('.loading__spinner');
        spinner.classList.remove('hidden');
        btn.disabled = true;

        if (!this.variantId) {
          console.error('Variant ID is missing.');
          return;
        }

        const formData = {
          items: [{ id: this.variantId, quantity: 1 }],
          sections: (document.querySelector('cart-notification') || document.querySelector('cart-drawer'))?.getSectionsToRender().map(s => s.id) || [],
          sections_url: window.location.pathname,
        };

        try {
          const response = await fetch("/cart/add.js", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
          });

          if (!response.ok) throw new Error(`Failed to add to cart: ${response.status}`);

          const data = await response.json();
          ////console.log('Product added to cart:', data);

          const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (cartDrawer) {
            cartDrawer.classList.toggle('is-empty', data.item_count === 0);
            cartDrawer.renderContents(data);
          }
          getRelatedid();
          this.parentElement.remove();

        } catch (error) {
          console.error('Error in addToCart:', error);
        } finally {
          spinner.classList.add('hidden');
          btn.disabled = false;
        }
      }
    }
  );
}

getRelatedid();



class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
      getRelatedid();
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    getRelatedid();
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);

      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

class CountryProvinceForm extends HTMLElement {
  constructor() {
    super();
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.template = this.dataset.template;
    this.countryElement.addEventListener('change', this.handleCountryChange.bind(this));
    if (this.template && this.template === 'cart') this.init();
  }

  init() {
    if (this.dataset.country) {
      this.countryElement.selectedIndex = Math.max(
        0,
        Array.from(this.countryElement.options).findIndex(
          (option) => option.textContent.trim() === this.dataset.country.trim()
        )
      );
      this.countryElement.dispatchEvent(new Event('change'));
    } else {
      this.handleCountryChange();
    }
  }

  handleCountryChange() {
    const option = this.countryElement.options[this.countryElement.selectedIndex];
    const provinces = JSON.parse(option.dataset.provinces || '[]');
    const postalCodeWrapper = this.closest('form').querySelector('.postal-code');
    const postalCodelabel = this.closest('form').querySelector('.postal-code .shipping_postal-code');
    this.provinceElement.closest('.fields_parent').hidden = provinces.length === 0;
    if (provinces.length > 0) {
      postalCodeWrapper.classList.remove('hidden');
      this.classList.add('grid_columns');
    } else {
      this.classList.remove('grid_columns');
      postalCodeWrapper.classList.add('hidden');
    }
    this.provinceElement.innerHTML = '';

    provinces.forEach(([value, text]) => {
      const selected = text === this.dataset.province;
      this.provinceElement.add(new Option(text, value, selected, selected));
    });
  }
}
customElements.define('country-province', CountryProvinceForm);

class ShippingCalculator extends HTMLFormElement {
  constructor() {
    super();
    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.querySelector('.shipping-rates-result');
    this.submitButton.addEventListener('click', this.handleFormSubmit.bind(this));
  }

  handleFormSubmit(event) {
    event.preventDefault();

    const zip = this.querySelector('[name="address[zip]"]').value;
    const country = this.querySelector('[name="address[country]"]').value;
    const province = this.querySelector('[name="address[province]"]').value;

    this.submitButton.classList.add('button--loading');

    fetch('/cart/shipping_rates.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shipping_address: { zip, country, province } }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.shipping_rates) {
          this.formatShippingRates(data.shipping_rates);
        } else {
          this.formatError(data);
        }
      })
      .catch((e) => this.formatError({ error: e.toString() }))
      .finally(() => {
        this.resultsElement.hidden = false;
        this.submitButton.classList.remove('button--loading');
      });
  }

  formatError(errors) {
    this.resultsElement.innerHTML = `
      <div class="alert alert--error">
        <p><strong>Error:</strong></p>
        <ul>${Object.values(errors)
        .map((msg) => `<li>${msg}</li>`)
        .join('')}</ul>
      </div>
    `;
  }

  formatShippingRates(rates) {
    const list = rates
      .map((r) => `<li>${r.presentment_name}: ${r.currency} ${r.price}</li>`)
      .join('');
    this.resultsElement.innerHTML = `
      <div class="alert alert--success">
        <p><strong>${rates.length > 1 ? 'Available rates:' : 'Rate found:'}</strong></p>
        <ul>${list}</ul>
      </div>
    `;
  }
}
customElements.define('shipping-calculator', ShippingCalculator, { extends: 'form' });





